import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Button, Table } from "antd";
import SearchBox from "../../../components/SearchBox";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import config from "../../../config";
import { getPropertyByKey } from "../../../utils/getPropertyByKey";
import { companyID } from "../../../auth";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Loader from "../../../components/Loader";
import AcknowledgmentPopup from "../../../utils/AcknowledgmentPopup";
import api from "../../../api/axios";
import AcknowledgeAssetPolicyModal from "../HR/Policies/AcknowledgeAssetPolicyModal";
import { decrypt } from "../../../utils/crypto";

const AssignedAsset = () => {
  let { employee_id } = useParams();
  employee_id = decrypt(employee_id);
  const location = useLocation();
  const { employeeName = "" } = location.state || {};
  const loginEmployeeId = localStorage.getItem("employeeID");
  const [assetStatus, setAssetStatus] = useState([]);
  const [assetType, setAssetType] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [employeeAsset, setEmployeeAsset] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [viewPdfFile, setViewPdfFile] = useState(null);
  const [selectedAssetId, setSelectedAssetId] = useState(null);
  const [loading, setLoading] = useState({
    show: false,
    message: "",
  });
  const [acknowledgmentPopup, setAcknowledgmentPopup] = useState({
    showAcknowledgmentPopup: false,
    popupVariant: "",
    popupMessage: "",
    popupIcon: "",
  });
  const [viewPolicy, setViewPolicy] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
    setViewPdfFile(null);
    setViewPolicy(false);
    setSelectedAssetId(null);
  };

  const hideAcknowledgmentPopup = () => {
    const resetAcknowledgmentPopupData = () => {
      setAcknowledgmentPopup({
        showAcknowledgmentPopup: false,
        popupVariant: "",
        popupMessage: "",
        popupIcon: "",
      });
    };
    setTimeout(() => resetAcknowledgmentPopupData(), 2000);
  };

  const handleModalSubmit = (data) => {
    if (selectedAssetId) {
      setLoading({ message: "Acknowledging Policy...", show: true });
      api
        .put(`employee-assets/${selectedAssetId}`, data)
        .then((res) => {
          setAcknowledgmentPopup({
            showAcknowledgmentPopup: true,
            popupVariant: "success",
            popupMessage: "Successfully Acknowledged Policy !",
            popupIcon: "fa-regular fa-circle-check",
          });
        })
        .catch((err) => {
          console.log(err);
          setAcknowledgmentPopup({
            showAcknowledgmentPopup: true,
            popupVariant: "danger",
            popupMessage: "Something went wrong, Try again !",
            popupIcon: "fa-regular fa-circle-xmark",
          });
        })
        .finally(() => {
          handleModalClose();
          setLoading({
            show: false,
            message: "",
          });
          hideAcknowledgmentPopup();
        });
    }
  };

  const company_id = companyID();

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const fetchEmployeesAssets = () => {
    api
      .get(`employee-assets/${company_id}?employee_id=${employee_id}`)
      .then((res) => {
        setEmployeeAsset(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        //loader
      });
  };

  useEffect(() => {
    if (company_id && employee_id) {
      fetchEmployeesAssets();
    }
  }, [showModal]);

  useEffect(() => {
    fetchAssetStatus();
    fetchAssetType();
  }, []);

  const fetchAssetStatus = () => {
    api
      .get(`assets-status`)
      .then((res) => {
        setAssetStatus(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchAssetType = () => {
    api
      .get(`asset-types`)
      .then((res) => {
        setAssetType(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const downloadFile = async (file) => {
    let policy;
    setLoading({
      message: "Downloading file...",
      show: true,
    });
    if (file) {
      api
        .get(`hr/policy-data-update/${file}`)
        .then(async (res) => {
          policy = res.data.result;
          try {
            setViewPdfFile(`${config.IMAGE_URL}${policy[0].policy_file}`);
          } catch (error) {
            console.error("Error downloading file:", error);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading({
            show: false,
            message: "",
          });
        });
    }
  };

  const columns = [
    {
      title: "Asset",
      dataIndex: "asset_type",
      key: "asset_type",
      render: (text) => text,
    },
    {
      title: "Serial number",
      dataIndex: "serial_number",
      key: "serial_number",
      render: (text) => text,
    },
    {
      title: "Manufacturer",
      dataIndex: "manufacturer",
      key: "manufacturer",
      render: (text) => text,
    },
    {
      title: "Model",
      dataIndex: "model",
      key: "model",
      render: (text) => text,
    },
    {
      title: "Assigned date",
      dataIndex: "assigned_date",
      key: "assigned_date",
      render: (text) => {
        if (text) {
          return text.split("T")[0];
        } else {
          return "-";
        }
      },
    },
    {
      title: "Policy",
      dataIndex: "policy",
      key: "policy",
      render: (text, record) => (
        <Button
          type="link"
          className="p-0"
          onClick={() => {
            downloadFile(text);
            setShowModal(true);
            setSelectedAssetId(record.id);
            setViewPolicy(true);
          }}
        >
          View
        </Button>
      ),
    },
    {
      title: "Policy acknowledged",
      dataIndex: "policy_acknowledged",
      key: "policy_acknowledged",
      render: (text) => (text == 1 ? "Yes" : "No"),
    },
    {
      title: "Received",
      dataIndex: "employee_received",
      key: "employee_received",
      render: (text) => (text == 1 ? "Yes" : "No"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <span className={`badge badge-${text == 1 ? "success" : "warning"}`}>
          {getPropertyByKey(assetStatus, "id", text, "name") ?? "-"}
        </span>
      ),
    },
    ...(loginEmployeeId === employee_id
      ? [
          {
            title: "Action",
            render: (text, record) => (
              <div className="d-flex gap-2 mt-2">
                <button
                  disabled={
                    record.policy_acknowledged == 0 &&
                    record?.return_received != 1
                      ? false
                      : true
                  }
                  className="btn p-0 border-0"
                  onClick={() => {
                    setShowModal(true);
                    downloadFile(record.policy);
                    setSelectedAssetId(record.id);
                  }}
                >
                  <i
                    className={`fa-solid fa-circle-${
                      record.policy_acknowledged ? "check" : "exclamation"
                    } m-r-5 ${
                      record.policy_acknowledged == 0
                        ? "text-warning"
                        : "text-success"
                    }`}
                    title={
                      record.policy_acknowledged == 1
                        ? "Policy Acknowledged"
                        : "Acknowledge Policy"
                    }
                  />
                </button>
              </div>
            ),
          },
        ]
      : []),
  ];
  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid position-relative">
          <Breadcrumbs
            maintitle={`${employeeName} Assigned Assets`}
            title="Dashboard"
            subtitle="Assigned Assets"
          />
          <SearchBox setPaginationValue={setPageSize} />
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <Table
                  className="table-striped"
                  columns={columns}
                  dataSource={employeeAsset}
                  rowKey={(record) => record.id}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    total: employeeAsset.length,
                    showSizeChanger: true,
                    onChange: handlePageChange,
                    pageSizeOptions: ["5", "10", "15"],
                  }}
                  scroll={{ x: true }}
                />
              </div>
            </div>
          </div>
          {viewPdfFile && (
            <AcknowledgeAssetPolicyModal
              show={showModal}
              onClose={handleModalClose}
              onSubmit={handleModalSubmit}
              pdfUrl={viewPdfFile}
              assignedDate={
                employeeAsset.find((asset) => asset.id === selectedAssetId)
                  ?.assigned_date || ""
              }
              viewPolicy={viewPolicy}
            />
          )}
          {loading.show && (
            <Loader show={loading.show} loadingMessage={loading.message} />
          )}
          {acknowledgmentPopup.showAcknowledgmentPopup ? (
            <AcknowledgmentPopup
              popupVariant={acknowledgmentPopup.popupVariant}
              popupMessage={acknowledgmentPopup.popupMessage}
              popupIcon={acknowledgmentPopup.popupIcon}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssignedAsset;
